import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ChatPage from './pages/ChatPage';
import TasksPage from './pages/TasksPage';
import NotificationsPage from './pages/NotificationsPage';
import SettingsPage from './pages/SettingsPage';
import LogsPage from './pages/LogsPage';
import LoginPage from './pages/LoginPage';
import { useAuthStore, isTokenExpired } from './store/authStore';
import './styles/globals.css';

export default function App() {
  const token = useAuthStore(s => s.token);
  const logout = useAuthStore(s => s.logout);

  // Un token scaduto/non valido resta in localStorage e salterebbe il login.
  // Lo ripuliamo all'avvio e lo ricontrolliamo periodicamente, così se scade
  // durante l'uso l'app torna automaticamente alla schermata di login.
  useEffect(() => {
    if (!token) return;
    if (isTokenExpired(token)) { logout(); return; }
    const id = setInterval(() => {
      if (isTokenExpired(useAuthStore.getState().token)) logout();
    }, 60000);
    return () => clearInterval(id);
  }, [token, logout]);

  if (!token || isTokenExpired(token)) return <LoginPage />;

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/chat" replace />} />
          <Route path="chat"          element={<ChatPage />} />
          <Route path="tasks"         element={<TasksPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="logs"          element={<LogsPage />} />
          <Route path="settings"      element={<SettingsPage />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}
